<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">

        <div class="card-base baslikBg">{{this.hastaIsim}} - Randevu Tanımla</div>
        <el-row>
            <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                     class="demo-ruleForm">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div>
                        <el-row>
                            <div class="animated fadeInUp"
                                 style="display: flex; justify-content: center; margin-top: 50px; margin-bottom: 30px">
                                <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                    <div class="tarih-border" style="width: 100%; padding-bottom: 20px !important;">
                                        <div class="tarih-border-icon">
                                            <i class="el-icon-date"></i>
                                        </div>
                                        <div style="overflow:hidden;">
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item label='Hekim: '
                                                                  prop="randevuHekim">
                                                        <el-select
                                                                filterable
                                                                v-on:change="hekimChange"
                                                                v-model="hastaForm.randevuHekim"
                                                                placeholder='Hekim Seçiniz'
                                                                style="width: 100%">
                                                            <el-option v-for="item in hastaForm.doktor"
                                                                       :key="item.hekimId"
                                                                       :label="item.adSoyad"
                                                                       :value="item.hekimId"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col v-if="randevuDash" :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item label='Hasta: '
                                                                  prop="randevuHasta">
                                                        <el-select
                                                                filterable
                                                                v-model="hastaForm.randevuHasta"
                                                                placeholder='Hekim Seçiniz'
                                                                style="width: 100%">
                                                            <el-option v-for="item in hastaForm.hasta"
                                                                       :key="item.hastaId"
                                                                       :label="item.adSoyad"
                                                                       :value="item.hastaId"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </el-col>

                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item prop="randevuTarihi">
                                                        <el-date-picker
                                                                v-model="hastaForm.randevuTarihi"
                                                                type="datetime"
                                                                :picker-options="dateRangeOptions"
                                                                format="yyyy-MM-dd HH:mm:ss"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="Randevu Tarihi"
                                                                default-time="12:00:00">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </div>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                        <div v-if="(!randevuDash && (hastaForm.randevuTarihi !== '' && hastaForm.randevuHekim !== '')) || (randevuDash && (hastaForm.randevuTarihi !== '' && hastaForm.randevuHekim !== '' && hastaForm.randevuHasta !== ''))">
                            <el-col :xl="6" :lg="8" :md="10" :sm="24" :xs="24" class="col-p" aria-disabled="true">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft"
                                     style="position: relative">
                                    <el-form-item
                                            style="position: relative"
                                            prop="disId'">
                                        <dis-s-v-g-ran :ceruygulama="hastaForm.cerrahiUygList" :randevu="hastaForm.randevuList"></dis-s-v-g-ran>
                                        <div v-if="disIdRan !==''" class="animated fadeIn gharipDis"></div>
                                        <span v-if="disIdRan !==''" class="animated fadeIn gharipDisYazi">{{disIdRan}}</span>
                                        <el-button v-if="disIdRan !==''" size="mini" class="disIptalButon" @click="disIptalRan(disIdRan)">
                                            İptal
                                        </el-button>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :xl="18" :lg="16" :md="14" :sm="24"
                                    :xs="24" class="col-p">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft dis-sol">
                                    <el-col :span="24" class="col-p" style="padding: 70px 0;">
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Planlanan Uygulama: '
                                                          prop="ekTedaviIdRan">
                                                <el-select
                                                        v-on:change="disOnayKaydetRan(disIdRan);getEkUrunlerList()"
                                                        :disabled="rightDisableRan"
                                                        filterable
                                                        v-model="ekTedaviIdRan"
                                                        placeholder='Ek Tedavi Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekTedaviList"
                                                               :key="item.ektedaviId"
                                                               :label="item.baslik"
                                                               :value="item.ektedaviId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Protetik Ürün: ' prop="ekUrunIdRan">
                                                <el-select
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        filterable
                                                        v-model="ekUrunIdRan"
                                                        placeholder='Ek Ürün Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekUrunList"
                                                               :key="item.ekurunId"
                                                               :label="item.baslik"
                                                               :value="item.ekurunId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Lot: ' prop="ekUrunLotRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        @input="ekUrunLotRan=ekUrunLotRan.toUpperCase()"
                                                        v-model="ekUrunLotRan"
                                                        placeholder='Lot Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='ISQ: ' prop="isqRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        v-mask="'####################'"
                                                        v-model="isqRan"
                                                        placeholder='ISQ Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Açıklama: ' prop="aciklamaRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        v-model="aciklamaRan"
                                                        placeholder='Açıklama'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </div>
                            </el-col>
                        </div>
                    </div>
                </el-col>

            </el-form>
        </el-row>
        <el-col :span="24">

            <el-button class="margin-bottom-50 estas-buton ileriButton" size="small"
                       type="primary"
                       style="float: right;margin-top: 15px;"
                       @click="randevuTanimlama">
                Kaydet
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                </svg>
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import DisSVGRan from '@/components/DisSVGRan'

    import EventBus from '@/components/event-bus'
    import hekimService from '../../../WSProvider/HekimService'
    import cerrahiService from '../../../WSProvider/CerrahiService'
    import randevuService from '../../../WSProvider/RandevuService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';
    import hastaService from "../../../WSProvider/HastaService";

    let $ = JQuery;
    export default {
        name: "HastaTanimlama",

        components: {
            DisSVGRan
        },
        data() {
            return {

                disIdRan: '',
                eskiDisId: '',
                ekUrunIdRan: '',
                ekUrunLotRan: '',
                ekTedaviIdRan: '',
                isqRan: '',
                aciklamaRan: '',
                rightDisableRan: true,
                randevuDash: false,






                hastaId: '',
                hekimId: '',
                updateId: '',
                hastaIsim: '',

                ekUrunList: [],
                ekTedaviList: [],
                ekTedaviListKlon: [],

                dateRangeOptions: {
                    firstDayOfWeek: 1,
                },
                hastaForm: {
                    randevuTarihi: '',
                    randevuHekim: '',
                    randevuHasta: '',
                    hasta: '',
                    doktor: '',
                    randevuList: [],

                },
                rulesHasta: {
                    randevuTarihi: [{
                        required: true,
                        message: "Lütfen Randevu Tarihi Seçiniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            let self =  this;


            if(this.$store.getters.getRandevuTarih){
                this.hastaForm.randevuTarihi=this.$store.getters.getRandevuTarih;
                this.randevuDash = true;
                this.getHekimList();
            }else{
                this.hastaForm.randevuHasta = this.$store.state.hastaId;
                this.hastaForm.doktor = this.$store.state.hekimId;
                this.getHastaIsim();
            }

            this.getEkUrunList();
            this.getEkTedaviList();


            EventBus.$on('denemeRan', function (disId) {
                if (disId) {
                    self.rightDisableRan = false;
                    if (self.disIdRan !== '') {
                        self.disOnayKaydetRan(self.disIdRan)
                    }
                    self.disIdRan = disId;
                    var obj = self.hastaForm.randevuList.find(data => data.disId === disId)
                    if (obj) {
                        self.ekUrunIdRan = obj.ekUrunId;
                        self.ekUrunLotRan = obj.ekUrunLot;
                        self.isqRan = obj.isq;
                        self.aciklamaRan = obj.aciklama;
                        self.ekTedaviIdRan = obj.ekTedaviId;
                    }else{
                        self.ekUrunIdRan = '';
                        self.ekUrunLotRan = '';
                        self.isqRan = '';
                        self.aciklamaRan = '';
                        self.ekTedaviIdRan = '';
                    }
                }
            });

        },
        methods: {
            getHekimList() {
                hekimService.hekimList(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.hastaForm.doktor = response.data;
                    } else notification.Status(response.status, this)
                })
            },
            getEkUrunlerList(disIdRan) {
                cerrahiService.tedaviEkUrunListesi(1, "", "", this.ekTedaviIdRan).then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data
                    } else notification.Status(response.status, this)
                })

            },
            hekimChange(val) {
                hekimService.hekimHastaList(val).then((response) => {
                    if (response.status === 200) {
                        this.hastaForm.hasta = response.data;
                    } else notification.Status(response.status, this)
                })
            },
            disOnayKaydetRan(disId) {
                let self = this;
                var obj = self.hastaForm.randevuList.find(data => data.disId === disId)
                if (obj === undefined) {
                    self.hastaForm.randevuList.push({
                        disId: disId,
                        ekUrunId: self.ekUrunIdRan,
                        ekUrunLot: self.ekUrunLotRan,
                        isq: self.isqRan,
                        aciklama: self.aciklamaRan,
                        ekTedaviId: self.ekTedaviIdRan,
                    });
                } else {
                    obj.ekUrunId = self.ekUrunIdRan;
                    obj.ekUrunLot = self.ekUrunLotRan;
                    obj.isq = self.isqRan;
                    obj.aciklama = self.aciklamaRan;
                    obj.ekTedaviId = self.ekTedaviIdRan;
                }


            },
            disIptalRan(disId) {
                this.disIdRan = '';
                var obj = this.hastaForm.randevuList.find(data => data.disId === disId);
                this.hastaForm.randevuList.splice(this.hastaForm.randevuList.indexOf(obj),1);
                this.ekUrunIdRan = '';
                this.ekUrunLotRan = '';
                this.isqRan = '';
                this.aciklamaRan = '';
                this.ekTedaviIdRan = '';
                EventBus.$emit("disListRan", true)
            },
            hekimAdii(val) {
                var obj = this.hekimList.find(data => data.hekimId === val);
                return obj.adSoyad
            },
            randevuTanimlama() {
                randevuService.randevuKaydi(this.hastaForm.randevuHekim, this.hastaForm.randevuHasta,  this.hastaForm.randevuTarihi, this.hastaForm.randevuList).then((response) => {
                    if (response.status === 200) {
                        var max = 0xffffff;
                        var renk = '#' + Math.round(Math.random() * max).toString(16);
                        // Object.keys(response.data).forEach(function (e) {
                        //     console.log(e)
                        // })
                        EventBus.$emit("randevuList", true);
                        notification.Status('success', this, "Randevu başarıyla eklendi.");
                        this.resetForm('hastaForm');
                    }
                });
            },
            getHastaIsim() {
                hastaService.hastaDetay(this.hastaForm.randevuHasta).then((response) => {
                    if (response.status === 200) {
                        this.hastaIsim=response.data.adSoyad
                    } else notification.Status(response.status, this)
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "randevutanimlama");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "randevutanimlama") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            getEkUrunList(val) {
                cerrahiService.ekUrunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data;
                    } else notification.Status(response.status, this)
                })
            },
            getEkTedaviList() {
                cerrahiService.ekTedaviListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekTedaviList = response.data;
                        this.ekTedaviListKlon = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            open(val) {
                this.$notify.success({
                    title: 'Başarılı',
                    message: val + ' başarıyla eklendi.',
                    offset: 100
                });
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },

            rndEkle() {
                this.open('Randevu');
                this.hastaForm.randevuList.push({
                    ekUrunId: '',
                    ekUrunLot: '',
                    isq: '',
                    ekTedaviId: '',
                    aciklama: '',
                })
            },
            removeRnd(item) {
                this.hastaForm.randevuList.splice(item, 1);
            },

            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            }
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        right: 5px;
        bottom: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }

    .esnek-kutu {
        display: flex;
        justify-content: center;
    }

    .ileriButton {
        margin-right: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .geriButton {
        margin-left: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .siraNo {
        position: absolute;
        background: #9a9a9a;
        top: -5px;
        left: 0;
        border-radius: 0px 5px 5px 0px;
        padding: 5px 10px;
        color: #fff;
        font-weight: bold;
    }


    #agizGorunumu {
        position: relative;
        z-index: 100;
        margin: auto;
        display: block
    }

    #agizGorunumu path {
        cursor: pointer;
        position: relative;
        z-index: 50
    }

    /*#agizGorunumu path:hover {*/
    /*fill: #00cbc0!important*/
    /*}*/

    #agizGorunumu path[data-aktifdis=aktifDis],
    .seciliDis {
        fill: #00cbc0 !important
    }


    #agizGorunumu path[data-index=zIndexPath] {
        position: relative;
        z-index: 100;

    }

    #agizGorunumu path[data-index=zIndexPath]:hover {
        fill: #00cbc0 !important

    }

    .hastaKabulBaslik {
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }

    .hastaKabulBaslik h1 {
        background: #161c3c;
        color: #fff;
        font-weight: 700;
        padding: 8px 20px;
        position: relative;
    }

    .hastaKabulFormu {
        position: relative;
        z-index: 10;
    }

    .formBilgileri {
        display: flex;
    }

    .ozel-sagayasla {
        float: right;
    }

    .formBilgiBaslik {
        writing-mode: tb-rl;
        transform: rotate(180deg);
        float: left;
        text-align: center;
        background: #161c3c;
        color: #fff;
        padding: 12px 2px;
        text-transform: uppercase;
        font-weight: 600;
        position: relative;
        min-height: 250px;
    }

    .mobil-baslik {
        display: none;
        text-align: center;
        background: #161c3c;
        padding: 5px 2px;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        color: #fff;
    }

    .formElemanlari {
        padding: 0 20px !important;
    }

    .input-effect {
        position: relative;
        display: flex;
        align-items: flex-start;
    }

    .input-effect .formBilgi {
        height: 100%;
        padding: 10px 10px 0;
        font-size: 14px;
        font-weight: 500;
        flex-shrink: 0;
        min-width: 90px;
    }


    .yazdir-bilgisi {
        font-size: 14px;
        padding: 5px;
    }

    .effect-7, .effect-8, .effect-9 {
        border: 1px solid transparent;
        padding: 10px 10px 0;
        transition: .4s;
        width: 100%;
    }

    .formBilgiBaslik.sagTaraf {
        transform: none;
    }

    .formBilgiBaslik:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 27px;
        transform: translate(0, -50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 10px 0;
        border-color: transparent #161c3c transparent transparent;
    }

    .grupBilgisi {
        background: linear-gradient(90deg, rgba(22, 28, 60, 0) 5%, rgba(22, 28, 60, 0.5) 25%, rgba(22, 28, 60, 1) 40%, rgba(22, 28, 60, 1) 60%, rgba(22, 28, 60, 0.5) 75%, rgba(22, 28, 60, 0) 95%);
        font-size: 14px;
        font-weight: 500;
        padding: 8px 6px;
        text-align: center;
    }

    .grupBilgisi p {
        margin: 0;
        color: #fff;
    }

    .disOpsiyonlari {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        width: 100%;
        padding-top: 10px;
        page-break-inside: avoid;
        justify-content: center;
    }

    .yazdirFormSayfa .disNumarasi-yazdir {
        border-bottom: 1px solid #eee;
    }

    .opsiyonDiv {
        padding: 6px 5px;
        width: 23%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }


    .doktor-bilgi {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }


    .opsiyonDiv:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        right: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disler-arasi-cizgi {
        height: 2px;
        width: 100%;
        margin: 8px 0;
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disNumarasi-yazdir div:first-child {
        color: #3cbcb4;
        text-transform: uppercase;
    }

    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .disNumarasi-yazdir div:last-child {
        font-weight: 700;
    }

    .disNumarasi-yazdir div:last-child span {
        padding: 3px 7px;
        border: 1px solid #00bcb4;
        color: #0a716b;
        display: inline-block;
    }


    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .ozel-row {
        display: flex;
        justify-content: center;
    }

    @media only screen and (max-width: 480px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 60px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 86px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

</style>
<style lang="scss">
    .seciliDis {
        fill: #00cbc0 !important
    }

    .deaktifDis {
        opacity: .3;
        //pointer-events:none;
    }

    .seciliDis.deaktifDis {
        opacity: 1;
    }

</style>